import React from "react";
import { SVG } from "shared";
import { SVG_ENUM, HOME_SCROLL_ENUM } from "enums";
import "./WhatInvestorNeeds.scss";

const cards = [
  {
    icon: SVG_ENUM.WALLET,
    header: "Lista spółek zakupionych i dostępnych w Reliance",
    text: "Przejrzysty widok posiadanych udziałów wraz ze szczegółowymi danymi o spółkach, takimi jak branża, wycena, waluta, data publikacji na giełdzie oraz historia transakcji.",
  },
  {
    icon: SVG_ENUM.NOTIFICATION_TEXT,
    header: "Aktualizacje rynkowe i powiadomienia",
    text: "Automatyczne powiadomienia o zmianach dotyczących zakupionych spółek. Kluczowe wydarzenia zawsze dostępne w jednym miejscu — bez konieczności kontaktu z doradcą.",
  },
  {
    icon: SVG_ENUM.PRESENTATION_CHART,
    header: "Zlecanie analiz rynkowych",
    text: "Możliwość zamówienia indywidualnej analizy dowolnej spółki. Po ukończeniu analizy użytkownik otrzymuje dokument z rekomendacjami bezpośrednio w aplikacji.",
  },
];

const WhatInvestorNeeds: React.FC = () => {
  return (
    <section
      className="layout what-investor-needs"
      id={HOME_SCROLL_ENUM.INVESTOR}
    >
      <div className="what-investor-needs__top">
        <h2 className="what-investor-needs__header">
          Wszystko, czego potrzebuje <i>inwestor</i>
        </h2>
        <p className="what-investor-needs__text">
          Aplikacja została zaprojektowana z myślą o inwestorach, którzy
          oczekują pełnego dostępu do informacji, kontroli i wygody. Umożliwia
          bieżący wgląd w posiadane udziały, szybki dostęp do informacji
          rynkowych oraz wspiera proces podejmowania decyzji inwestycyjnych
          poprzez dedykowane analizy.
        </p>
      </div>
      <div className="what-investor-needs__cards">
        {cards.map((card, idx) => (
          <div className="what-investor-needs__card" key={idx}>
            <div className="what-investor-needs__icon">
              <SVG type={card.icon} />
            </div>
            <div className="what-investor-needs__card-content">
              <h3 className="what-investor-needs__card-header">
                {card.header}
              </h3>
              <p className="what-investor-needs__card-text">{card.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhatInvestorNeeds;
